module.exports = __webpack_public_path__ + "img/1645_c.29d8a585.png";